import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_locked from "@/Globals/_images/locked.png";
import img_unlocked from "@/Globals/_images/unlocked.png";

interface LockControlProps {
    isLocked: boolean;
    onClick: () => void;
}

class LockControl extends BaseReactComponent<LockControlProps, null> {
    public render(): JSX.Element {
        const imageSrc = this.props.isLocked
            ? img_locked
            : img_unlocked;

        return (
            <img
                style={{ height: "40px", width: "42px", paddingBottom: "5px" }}
                src={imageSrc}
                alt={cacheStore.GetString("RememberLabel")}
                onClick={() => this.props.onClick()}
            />
        );
    }
}

export { LockControl };
